import ContentBase from '../eyejack-web-core/src/content/core/content.base';
import { IAssetAudio, IAssetBase, IAssetCubeTexture, IAssetModel } from '../eyejack-web-core/src/apps/app.content';
import { AbstractMesh, AnimationGroup, Color3, CubeTexture, Engine, PBRMaterial, Sound, StandardMaterial, Vector3 } from 'babylonjs';
import ImmersalWireframePath from "../../assets/TestImmersalWireframe.glb";

import AnimationPath from '../../assets/Model.glb';
import { animateMeshesWithStagger } from './animation';

export default class ContentSimple extends ContentBase {
  
  private animation?: IAssetModel;
  private meshes: AbstractMesh[] = [];
  
  constructor() {
    super();
  }

  public override get assets(): IAssetBase[] {
    return [
      {
        id: "animation",
        type: "model",
        path: AnimationPath,
      },
			{
				id: "immersal-wireframe",
				type: "model",
				path: ImmersalWireframePath
			}
    ];
  }

  public override loadAssetComplete(asset: IAssetBase): void {
    if( asset.type === 'model' ) {
      const assetModel = asset as IAssetModel;
      (assetModel.meshes || []).forEach((mesh) => {
        this.meshes.push( mesh );
        mesh.isVisible = false;
      });
    }
    if( asset.id === 'animation' ) {
      this.animation = asset as IAssetModel;
      if( this.animation.meshes ) {
        this.animation.meshes.forEach((mesh) => {
          if (mesh.material && mesh.material instanceof PBRMaterial) {
            mesh.alwaysSelectAsActiveMesh = true;
						mesh.material.emissiveTexture = mesh.material.albedoTexture;
						mesh.material.emissiveColor = new Color3(1, 1, 1);
						
						mesh.material.backFaceCulling = false;
						mesh.material.needDepthPrePass = true;

						mesh.material.albedoTexture!.hasAlpha = true;
						mesh.material.transparencyMode = PBRMaterial.PBRMATERIAL_ALPHATESTANDBLEND;

          }
        });
      }
    } 
		if (asset.id === 'immersal-wireframe') {
			const assetModel = asset as IAssetModel;
			(assetModel.meshes || []).forEach((mesh) => {
				const material = new StandardMaterial("mat", this.scene);
				material.wireframe = true;
				material.disableLighting = true;
				material.backFaceCulling = false;
				material.diffuseColor = new Color3(1, 1, 1);
				material.emissiveColor = new Color3(1, 1, 1);
				material.alpha = 0.3;
				mesh.material = material;
			});
		}
  }

  public get isReady(): boolean {
    let ready = true;
    ready = ready && this.animation !== undefined;
    return ready;
  }

  public play(): void {
    if( !this.isReady ) {
      return;
    }
    this.meshes.forEach((mesh) => {
      mesh.isVisible = true;
    });

		if (this.scene)
			animateMeshesWithStagger(this.meshes, this.scene, 0.5, 0.2);
    
    if (Engine.audioEngine) {
      Engine.audioEngine.audioContext?.resume();
    }
  }
  
  public stop(): void {
    if (!this.isReady) {
      return;
    }
    this.meshes.forEach((mesh) => {
      mesh.isVisible = false;
    });
    const animations = this.animation!.animations;
    if (animations && animations.length > 0) {
      animations.map((anim: AnimationGroup) => {
        anim.stop();
      });
    }
    if (Engine.audioEngine) {
      Engine.audioEngine.audioContext?.suspend();
    }
  }
}